import cleanedFilename from '~/util/cleanedFilename';

export default {
  RIM: `${cleanedFilename(__filename)}-rim`,
  CONTROLS: `${cleanedFilename(__filename)}-controls`,
  STOP: `${cleanedFilename(__filename)}-stop`,
};
